<template>
  <div class="col-12 flex justify-center mt3 flex-column">
    <TerrainHeader :show-participant-card="true" />

    <div>
      <h3 class="h5">Location & matériel</h3>

      <div v-for="(option, index) in options" :key="`option_${index}`" class="flex white-bg p1" :class="{ 'mt2': index !== 0 }">
        <div class="flex col-6">
          <div class="flex flex-column h6">
            {{ option.name }}
            <span class="h7">Tarif = {{ computePrice(option.price.price) }} €</span>
          </div>
        </div>
        <div class="flex col-6">
          <div class="col-7 flex justify-end items-center">
            <div class="h6 light-cyan-bg p1 cust-border" :style="{ '--cust-border-color': 'var(--light-cyan)' }" @click="handleQuantityChange(index, -1)">
              <i style="top: 3px" :class="[{'icon icon-minus-1 pointer': true},{'disabled':isQuantityPickerDisabled(option, -1)}]"></i>
            </div>
            <div class="h6 cust-border p1" :style="{ '--cust-border-color': 'var(--light-cyan)' }">
              {{ option.quantity }}
            </div>
            <div class="h6 light-cyan-bg p1 cust-border" :style="{ '--cust-border-color': 'var(--light-cyan)' }" @click="handleQuantityChange(index, 1)">
              <i style="top: 3px" :class="[{'icon icon-plus pointer': true},{'disabled':isQuantityPickerDisabled(option, 1)}]"></i>
            </div>
          </div>
          <div class="col-5 flex items-center justify-end h6">
            {{ computePrice(option.price.price * option.quantity) }} €
          </div>
        </div>
      </div>
    </div>

    <StepAction @handleClickAction="handleOptionStep" />
  </div>
</template>

<script setup>

import { computed, onBeforeMount, inject } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from '@/store/index';

import TerrainHeader from '@/components/terrain/TerrainHeader.vue';
import StepAction from '@/components/terrain/StepAction.vue';
import { computePriceLabel } from '@/utils/utils';
import { computeCourtDataLayer } from '@/utils/index';

const store = useStore();
const route = useRoute();

const advanceStep = inject('advanceStep');

const options = computed(() => store.state.courtSettings.availableOptions);

const computePrice = price => computePriceLabel(price);

const isQuantityPickerDisabled = (option, quantity) => {
  if (option.fixedQuantity) {
    return true;
  }

  const newQuantity = option.quantity + quantity;

  return option.optionType === 'MANDATORY' ? true : newQuantity < 0;
};

const handleQuantityChange = (option, quantity) => {
  options.value[option].quantity += quantity;

  store.commit('setCourtSettings', { ...store.state.courtSettings, selectedOptions: options.value });
};

const handleOptionStep = () => {
  computeCourtDataLayer('CourtOptions', { ...store.state.courtSettings }, route.fullPath, { ...store.state.product }, { ...store.state.offerInfo });

  const selectedOptions = options.value.filter(option => option.quantity > 0);

  store.commit('setCourtSettings', { ...store.state.courtSettings, selectedOptions: selectedOptions });

  advanceStep();
};

onBeforeMount(() => {
  const selectedOptions = options.value.filter(option => option.quantity > 0);
  store.commit('setCourtSettings', { ...store.state.courtSettings, selectedOptions: selectedOptions });
});

</script>
